<template>
    <HamletTable
        :fetch="fetch"
        :columns="columns"
        @onRowClick="edit"
    >
        <template #header-label>
            {{ $t('Page(Subscribers):Component(Text):page-label') }}
        </template>

        <template #header-controls>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-0 btn-icon"
                @click="add"
            >
                <feather-icon icon="PlusIcon" />
            </b-button>
        </template>

        <template #cell-manageable="data">
            <b-badge :variant="data.item.isManageable ? 'success' : 'danger'">
                {{ data.item.isManageable ? 'Yes' : 'No' }}
            </b-badge>
        </template>

        <template #cell-country="data">
            <span v-if="data.item.organization">
                {{ data.item.organization.state ? data.item.organization.state.title : '-' }}
            </span>
        </template>

        <template #cell-chemity="data">
            {{ (subscription = getApplicationSubscription('chemity', data.item.subscriptions), null) }}
            <OngoingDateBadge
                v-if="subscription"
                :date="subscription.validTo"
            />
            <div v-else>-</div>
        </template>

        <template #cell-sustainity="data">
            {{ (subscription = getApplicationSubscription('sustainity', data.item.subscriptions), null) }}
            <OngoingDateBadge
                v-if="subscription"
                :date="subscription.validTo"
            />
            <div v-else>-</div>
        </template>
    </HamletTable>
</template>

<script>
import {BBadge, BButton} from 'bootstrap-vue'
import HamletTable from "@core/components/common/HamletTable";
import {SubscriberApi} from "@core/api";
import Ripple from 'vue-ripple-directive'
import dateRenderer from "@core/mixins/date-renderer";
import OngoingDateBadge from "@core/components/common/OngoingDateBadge.vue";
import LegalIdentity from "@core/components/common/LegalIdentity.vue";
import subscriptions from "@/views/administration/subscriber/components/Subscriptions.vue";

export default {
    mixins: [dateRenderer],
    directives: {Ripple},
    components: {
        LegalIdentity,
        HamletTable, BBadge, BButton, OngoingDateBadge,
    },
    data() {
        return {
            columns: [
                {
                    key: 'id',
                    label: this.$t('Component(Grid):column-id')
                },
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-name')
                },
                {
                    key: 'country',
                    label: this.$t('Component(Grid):column-country')
                },
                {
                    key: 'manageable',
                    label: this.$t('Component(Grid):column-manageable')
                },
                {
                    key: 'chemity',
                    label: 'Chemity'
                },
                {
                    key: 'sustainity',
                    label: 'Sustainity'
                },
            ],
        }
    },
    methods: {
        fetch(config, cb) {
            SubscriberApi
                .subscribers([], {}, config.page, config.perPage)
                .then(r => {
                    cb(r.data.totalItems, r.data.items);
                })
            ;
        },
        add() {
            this.$router.push({
                name: 'administration-subscribers-add',
            });
        },
        edit(subscriber) {
            this.$router.push({
                name: 'administration-subscribers-edit',
                params: {id: subscriber.id}
            });
        },
        getApplicationSubscription(name, subscriptions) {
            if (null === subscriptions || undefined === subscriptions) {
                return null;
            }

            return subscriptions.find(s => s.application === name);
        },
    },
}
</script>
